import TmrBaseResource from './TmrBaseResource'

export default class Choices extends TmrBaseResource {
  static endpoint = '/choices'
}
